import React, { Component } from 'react';
import { FlipCard } from './FlipCard';
import { ArrowRight, TrendingUp, Users, MousePointer, Search } from 'lucide-react';
export function BentoGrid() {
  return <div className="w-full max-w-7xl mx-auto px-4 py-12" style={{
    isolation: 'isolate'
  }} data-id="element-2">
      <header className="mb-12 text-center" data-id="element-3">
        <h1 className="text-slate-900 mb-4" style={{
        fontSize: '2.2rem',
        fontWeight: 400,
        letterSpacing: '0.11em'
      }} data-id="element-4">
          Case Studies
        </h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5">
        {/* Card 1: Capital One (Featured - Spans 2 cols) */}
        <FlipCard className="lg:col-span-2" link="https://www.joshlau.com/learn-and-grow" frontContent={<div className="relative h-full w-full" data-id="element-7">
              <img src="https://cdn.magicpatterns.com/uploads/wdB8QZEQSNcXkmWhvJDvXb/pasted-image.webp" alt="Capital One Learn and Grow Case Study" className="h-full w-full object-cover" data-id="element-8" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-9" />
              <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-10">
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-11">
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-12">
                    Growth Design
                  </span>
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-13">
                    Design Systems
                  </span>
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-14">
                  Turning Content Into Growth
                </h2>
              </div>
            </div>} backContent={<div className="h-full w-full p-8 flex flex-col justify-between bg-white" data-id="element-15">
              <div data-id="element-16">
                <h3 className="text-lg font-bold text-slate-900 mb-4 leading-tight" data-id="element-17">
                  Optimizing for Reach: A UX Overhaul of Capital One's Learn &
                  Grow SEO Powerhouse
                </h3>
                <ul className="space-y-4 text-sm" data-id="element-18">
                  <li className="flex items-start text-slate-600" data-id="element-19">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-20" />
                    <span data-id="element-21">
                      Crafted a new template for over 2,000 individual articles
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-22">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-23" />
                    <span data-id="element-24">Impacted over 85% of all Capital One web pages</span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-25">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-26" />
                    <span data-id="element-27">
                      Contributed to driving 600k new card applications
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-28">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-29" />
                    <span data-id="element-30">
                      Increased total clicks and click through rates by 21%
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-31">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-32" />
                    <span data-id="element-33">
                      Optimized SEO to engage more SERP features by 17%
                    </span>
                  </li>
                </ul>
              </div>
              <span className="mt-6 self-start inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm tracking-wide font-medium" data-id="element-34">
                View project
              </span>
            </div>} data-id="element-6" />

        {/* Card 2: Capital One Help Center (Spans 1 col) */}
        <FlipCard className="lg:col-span-1" link="https://www.joshlau.com/help-center" frontContent={<div className="relative h-full w-full" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/uploads/rSE6VrDnA4bTBp4xDb8rLy/3e577f4d-5283-4e95-b503-363a37362323.png" alt="Capital One Help Center Redesign Case Study" className="h-full w-full object-cover" data-id="element-37" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-38" />
              <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-39">
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-40">
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-41">
                    Visual Design
                  </span>
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-42">
                    IA
                  </span>
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-43">
                  Helping Users Help Themselves
                </h2>
              </div>
            </div>} backContent={<div className="h-full w-full p-8 flex flex-col justify-between bg-white" data-id="element-44">
              <div data-id="element-45">
                <h3 className="text-base font-bold text-slate-900 mb-4 leading-tight" data-id="element-46">
                  Guiding Users with Confidence: Elevating Self-Serve Support
                  through Modular Design
                </h3>
                <ul className="space-y-3 text-sm" data-id="element-47">
                  <li className="flex items-start text-slate-600" data-id="element-48">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-49" />
                    <span data-id="element-50">
                      Led a cross-functional, data informed redesign of Capital
                      One's Help Center to improve usability and content
                      hierarchy
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-51">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-52" />
                    <span data-id="element-53">
                      Created new, reusable components to modernize the
                      experience and support scalability
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-54">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-55" />
                    <span data-id="element-56">
                      Prioritized content clarity and discoverability to better
                      meet customer support needs
                    </span>
                  </li>
                </ul>
              </div>
              <span className="mt-6 self-start inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm tracking-wide font-medium" data-id="element-57">
                View project
              </span>
            </div>} data-id="element-35" />

        {/* Card 3: Cross Brand Component (Spans 1 col) */}
        <FlipCard className="lg:col-span-1" link="https://www.joshlau.com/showcase" frontContent={<div className="relative h-full w-full" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/adRLgyuihgGiGZgWPMegN8/pasted-image.webp" alt="Cross Brand Component Case Study" className="h-full w-full object-cover" data-id="element-60" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-61" />
              <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-62">
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-63">
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-64">
                    Collaboration
                  </span>
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-65">
                  Scaling Design Across Brands
                </h2>
              </div>
            </div>} backContent={<div className="h-full w-full p-8 flex flex-col justify-between bg-white" data-id="element-66">
              <div data-id="element-67">
                <h3 className="text-base font-bold text-slate-900 mb-4 leading-tight" data-id="element-68">
                  Designing a Cross Brand Component
                </h3>
                <ul className="space-y-3 text-sm" data-id="element-69">
                  <li className="flex items-start text-slate-600" data-id="element-70">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-71" />
                    <span data-id="element-72">
                      Leveraged Capital One's dynamic design system to carefully
                      craft a new, editorial design component for use across
                      various lines of businesses
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-73">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-74" />
                    <span data-id="element-75">
                      Facilitated the marketing of cross-brand promotions across
                      the site
                    </span>
                  </li>
                </ul>
              </div>
              <span className="mt-6 self-start inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm tracking-wide font-medium" data-id="element-76">
                View project
              </span>
            </div>} data-id="element-58" />

        {/* Card 4: YellowTin Design System (Spans 2 cols) */}
        <FlipCard className="lg:col-span-2" link="https://www.joshlau.com/yellowtin" frontContent={<div className="relative h-full w-full" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/d9iaaQvfD5D3vdu1KekRSb/Frame_22_(2).png" alt="YellowTin Design System Case Study" className="h-full w-full object-cover" data-id="element-79" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-80" />
              <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-81">
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-82">
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-83">
                    Design Systems
                  </span>
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-84">
                    0→1
                  </span>
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-85">
                  Building a 0-1 Design System
                </h2>
              </div>
            </div>} backContent={<div className="h-full w-full p-8 flex flex-col justify-between bg-white" data-id="element-86">
              <div data-id="element-87">
                <h3 className="text-lg font-bold text-slate-900 mb-4 leading-tight" data-id="element-88">
                  Crafting a 0-1 Startup Design System
                </h3>
                <ul className="space-y-3 text-sm" data-id="element-89">
                  <li className="flex items-start text-slate-600" data-id="element-90">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-91" />
                    <span data-id="element-92">
                      Created a custom design system from scratch for
                      YellowTin's platform in order to optimize responsive
                      design work and build consistency across their web
                      products
                    </span>
                  </li>
                  <li className="flex items-start text-slate-600" data-id="element-93">
                    <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-94" />
                    <span data-id="element-95">
                      Owned end-to-end product design as the sole designer on
                      the team
                    </span>
                  </li>
                </ul>
              </div>
              <span className="mt-6 self-start inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm tracking-wide font-medium" data-id="element-96">
                View project
              </span>
            </div>} data-id="element-77" />

        {/* Card 5: Craigslist AI Redesign (Full width - Split Layout) */}
        <a href="https://www.joshlau.com/craigslist-ai" target="_blank" rel="noopener noreferrer" className="col-span-1 md:col-span-2 lg:col-span-3 grid grid-cols-1 md:grid-cols-2 h-auto md:h-[450px] rounded-2xl overflow-hidden shadow-lg group" data-id="element-97">
          {/* Image Side */}
          <div className="relative h-full w-full overflow-hidden" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/vj7iaFh9iEp3ziqyNmSaLh/Screen_Shot_2026-04-01_at_2.14.55_AM.png" alt="Craigslist AI Redesign Case Study" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-99" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" data-id="element-100" />
            <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-101">
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-102">
                <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-103">
                  AI
                </span>
                <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white uppercase bg-white/20 backdrop-blur-sm rounded-full" data-id="element-104">
                  Rapid Prototyping
                </span>
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-105">
                Rethinking Craigslist with AI
              </h2>
            </div>
          </div>

          {/* Content Side */}
          <div className="h-full w-full p-8 flex flex-col justify-between bg-white" data-id="element-106">
            <div data-id="element-107">
              <h3 className="text-lg font-bold text-slate-900 mb-4 leading-tight" data-id="element-108">
                Reimagining Craigslist: An AI-Assisted Marketplace Experience
              </h3>
              <ul className="space-y-4 text-sm" data-id="element-109">
                <li className="flex items-start text-slate-600" data-id="element-110">
                  <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-111" />
                  <span data-id="element-112">
                    Led a solo, AI-augmented redesign of Craigslist's mobile
                    marketplace to improve usability, scanning, and
                    decision-making.
                  </span>
                </li>
                <li className="flex items-start text-slate-600" data-id="element-113">
                  <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-114" />
                  <span data-id="element-115">
                    Leveraged AI tooling to rapidly explore layout variations
                    and stress test designs against real-world listing
                    variability.
                  </span>
                </li>
                <li className="flex items-start text-slate-600" data-id="element-116">
                  <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" data-id="element-117" />
                  <span data-id="element-118">
                    Prioritized clarity, speed, and trust while preserving the
                    simplicity and neutrality that define Craigslist's success.
                  </span>
                </li>
              </ul>
            </div>
            <span className="mt-6 self-start inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm tracking-wide font-medium transition-opacity duration-300 group-hover:opacity-80" data-id="element-119">
              View project
            </span>
          </div>
        </a>
      </div>
    </div>;
}